import React from 'react';
import { observer } from 'mobx-react-lite';

import { useRootStore } from '../../../root/RootStoreHooks';

interface Props {
  price: number;
  newSlMode?: boolean;
  numberOnly?: boolean;
}

export const MoneyDisplay = observer<Props>(({ price, newSlMode, numberOnly }) => {
  const { currency } = useRootStore().reference;
  return (
    <>
      <span className={newSlMode ? 'sl-product-price-amount' : ''}>
        {!newSlMode && !numberOnly && <>{currency.symbol}</>}
        {currency.formatDisplayAmount(price)}
      </span>
      {!numberOnly && <small> {currency.code}</small>}
    </>
  );
});
